// extracted by mini-css-extract-plugin
export default {"status":"ticket_status_T1Ls2","bntWrapper":"ticket_bntWrapper_FpPYO","btnGroup":"ticket_btnGroup_MQ2SN"};